import React, { useEffect, useState } from "react";
import { fetchSentimental } from "../services/apiService";

const SentimentalAnalysis = () => {
    const [trending, setTrending] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const data = await fetchSentimental();
            if (data && data.length > 0) {
                setTrending(data);
            } else {
                // Dummy data with sentiment
                setTrending([
                    {
                        name: "Ethereum",
                        symbol: "ETH",
                        mentions: 1350,
                        rank: 1,
                        sentiment: { positive: 60, neutral: 25, negative: 15 },
                    },
                    {
                        name: "Solana",
                        symbol: "SOL",
                        mentions: 980,
                        rank: 2,
                        sentiment: { positive: 50, neutral: 35, negative: 15 },
                    },
                    {
                        name: "Pepe",
                        symbol: "PEPE",
                        mentions: 720,
                        rank: 3,
                        sentiment: { positive: 30, neutral: 40, negative: 30 },
                    },
                    {
                        name: "Shiba Inu",
                        symbol: "SHIB",
                        mentions: 650,
                        rank: 4,
                        sentiment: { positive: 20, neutral: 50, negative: 30 },
                    },
                ]);
            }
        };
        fetchData();
    }, []);

    const renderGauge = (sentiment) => {
        const total = sentiment.positive + sentiment.neutral + sentiment.negative;
        const posPercent = (sentiment.positive / total) * 100;
        const neuPercent = (sentiment.neutral / total) * 100;
        const negPercent = (sentiment.negative / total) * 100;

        return (
            <div className="w-full h-3 mt-2 rounded bg-gray-800 flex overflow-hidden">
                <div className="h-full bg-green-500" style={{ width: `${posPercent}%` }} />
                <div className="h-full bg-gray-400" style={{ width: `${neuPercent}%` }} />
                <div className="h-full bg-red-500" style={{ width: `${negPercent}%` }} />
            </div>
        );
    };

    return (
        <section className="text-white">
            <h2 className="text-2xl font-bold text-fuchsia-400 mb-4">Sentimental Analysis</h2>
            <div className="space-y-4">
                {trending.map((item, index) => {
                    const imgUrl = `images/${item.symbol}.png`;
                    return (
                        <div
                            key={index}
                            className="flex items-center gap-4 bg-white/5 border border-fuchsia-600 rounded-xl p-4"
                        >
                            <img
                                src={imgUrl}
                                alt={item.symbol}
                                className="w-12 h-12 rounded-full border border-white/20 bg-white/10 object-contain"
                                onError={(e) => (e.target.style.display = 'none')}
                            />
                            <div className="flex-1">
                                <div className="flex justify-between gap-2 items-center flex-wrap md:flex-nowrap">
                                    <div className="min-w-0">
                                        <h3 className="text-md font-semibold text-fuchsia-300 truncate">
                                            {item.name} ({item.symbol})
                                        </h3>
                                        <p className="text-sm text-gray-300">
                                            Mentions: {item.mentions} | Rank: {item.rank}
                                        </p>
                                    </div>
                                    <div className="text-sm text-gray-400 text-right md:text-left">
                                        <p>Sentiment</p>
                                        <p>
                                            👍 {item.sentiment.positive}% | 😐 {item.sentiment.neutral}% | 👎{" "}
                                            {item.sentiment.negative}%
                                        </p>
                                    </div>
                                </div>
                                {renderGauge(item.sentiment)}
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default SentimentalAnalysis;
